import React from 'react';

import {
  BetStatus,
  ListItem,
  ListItemCont,
  ListItemCell,
  ListElemImage,
  convertAmount,
  parseNumberByPrecision,
  ListElemText,
} from '@pascal/pascal-core';
import { candiesByIndex, TranslationKeys } from '../../../enums';

const MyBets = ({ t, data }) => {
  return (
    <>
      {data?.betData?.map((betData) => {
        return (
          <ListItemCont
            key={`${data.playerExternalId ? data.id : data.date}_${betData.candy}`}
            forRemove={data.status !== BetStatus.Pending}
            animationDelayInSeconds={1.4}
          >
            <ListItem active={betData.winAmount}>
              <ListItemCell>
                <ListElemText style={{ textTransform: 'capitalize' }}>
                  {t(TranslationKeys.Me)}
                </ListElemText>
              </ListItemCell>
              <ListItemCell>
                <ListElemImage imageSrc={candiesByIndex[betData.candy]} alt='candy' />
              </ListItemCell>
              <ListItemCell>
                <ListElemText>
                  {data.freeBetId ? t(TranslationKeys.FreeBet) : convertAmount(betData.amount)}
                </ListElemText>
              </ListItemCell>
              <ListItemCell>
                <ListElemText>
                  {data.status === BetStatus.Pending
                    ? '...'
                    : convertAmount(parseNumberByPrecision(1, betData.winAmount))}
                </ListElemText>
              </ListItemCell>
            </ListItem>
          </ListItemCont>
        );
      })}
    </>
  );
};
export default MyBets;
